export function limitedPlanPriceSupplement(cost: number, numberOfMonths: number) {
  const monthlyCost = cost / numberOfMonths
  const isDecimal = !Number.isInteger(monthlyCost)
  const yaku:string = isDecimal ? "約 " : ""
  return `（${yaku} ${Math.round(monthlyCost).toLocaleString()}円 x ${numberOfMonths}ヶ月分）`
}